export default __webpack_public_path__ + "a043eb2354539e055904430c3f18e8b3.svg";